import SVG_AMZSCOUT_CN from "../../../assets/images/vector/Layout/Footer/logo_amzscout_cn.svg";
import SVG_AMZSCOUT from "../../../assets/images/vector/Layout/Footer/logo_amzscout.svg";

export const URL_LABEL = "r=footer";
export const ANALYTICS_CATEGORY = "Footer"

export const AVAILABLE_LOGOS = {
  cn: {
    logoPath: `/cn/?${URL_LABEL}`,
    logoSrc: SVG_AMZSCOUT_CN
  },
  de: {
    logoPath: `/de/?${URL_LABEL}`,
    logoSrc: SVG_AMZSCOUT
  },
  en: {
    logoPath: `/?${URL_LABEL}`,
    logoSrc: SVG_AMZSCOUT
  },
  ja: {
    logoPath: `/jp/pro/?${URL_LABEL}`,
    logoSrc: SVG_AMZSCOUT
  },
  fr: {
    logoPath: `/fr/?${URL_LABEL}`,
    logoSrc: SVG_AMZSCOUT
  },
  es: {
    logoPath: `/es/?${URL_LABEL}`,
    logoSrc: SVG_AMZSCOUT
  },
};

